export const workloadHeat = (load) =>
  load >= 12 ? { label: "Overloaded", bg: "#DC2626" }
  : load >= 8 ? { label: "Heavy", bg: "#EA580C" }
  : load >= 4 ? { label: "Moderate", bg: "#D97706" }
  : { label: "Light", bg: "#059669" };
